import { Receipt } from '@fhs-legacy/frontend/src/pages/receipt';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default Receipt;
